import { djsAnchors, isLaterDay } from './dates';

/**
 * Is this portfolio still running? The Portfolios screen's own Active/Completed
 * split, which the server draws as `end_date <= now` is completed — so a
 * portfolio whose last day is today is already done. A portfolio with no end
 * date has not ended. Share this rather than re-deriving it per screen.
 */
export function isActivePortfolio(portfolio: { endDate?: string | Date | null }): boolean {
  if (!portfolio?.endDate) return true;
  if (!portfolio?.endDate) return true;
  return isLaterDay(portfolio.endDate, djsAnchors.today);
}
